import {
  UPDATE_ADDRESS,
  UPDATE_POSITIONS,
} from '../constants';

const DEFAULT_STATE = {
  positions: {},
};

const PositonsReducer = (state = DEFAULT_STATE, { type, payload }) => {
  switch (type) {
    case UPDATE_POSITIONS:
      payload.forEach(
        (position) => (state.positions[position.deviceId] = position)
      );
      return {
        ...state,
      };
    case UPDATE_ADDRESS:
      return {
        ...state,
      };
    default:
      return state;
  }
};

export default PositonsReducer;
